import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AlertService } from "../../services/alert.service";
import { ProductsService } from "../../services/products.service";

@Component({
    selector: "app-product-types",
    templateUrl: "./product-types.component.html",
    styleUrls: ["./product-types.component.scss"],
})
export class ProductTypesComponent implements OnInit {
    @Input() productRange;
    @Output() next = new EventEmitter();
    @Output() exitStep = new EventEmitter();
    @Output() productRangeUpdated = new EventEmitter();

    productTypes = [];
    configData;

    constructor(
        private productsService: ProductsService,
        private alertService: AlertService
    ) {}

    ngOnInit(): void {
        if (!this.productRange) {
            // this.alertService.error(['Product range must be loaded first']);
            this.exitStep.emit();
        } else {
            this.getProductTypes();
        }
    }

    getProductTypes() {
        this.productsService
            .getProductTypes({ status: true })
            .subscribe((data) => {
                this.productTypes = data.data;
            });
    }

    productTypeSelected(id) {
        for (let i = 0; i < this.productRange.productTypes.length; i++) {
            if (this.productRange.productTypes[i].id === id) {
                return i;
            }
        }
        return -1;
    }

    productTypeBespokeAllowed(id) {
        for (let i = 0; i < this.productRange.productTypes.length; i++) {
            if (this.productRange.productTypes[i].id === id) {
                if (this.productRange.productTypes[i].allowBespoke) {
                    return true;
                } else {
                    return false;
                }
            }
        }
        return false;
    }

    toggleProductTypes(productType) {
        const currentIndex = this.productTypeSelected(productType.id);
        if (currentIndex >= 0) {
            this.productRange.productTypes.splice(currentIndex, 1);
        } else {
            this.productRange.productTypes.push(productType);
        }
    }

    toggleProductTypeBespoke(pt) {
        const currentIndex = this.productTypeSelected(pt.id);
        if (currentIndex >= 0) {
            if (!this.productRange.productTypes[currentIndex].allowBespoke) {
                this.productRange.productTypes[currentIndex].allowBespoke = 1;
            } else {
                this.productRange.productTypes[currentIndex].allowBespoke = 0;
            }
        }
    }

    editProductType(pt) {
        this.configData = {
            productType: pt,
            range: this.productRange,
        };
    }

    continue() {
        this.productsService
            .updateProductRange(this.productRange)
            .subscribe((data) => {
                this.productRangeUpdated.emit(data.data);
                this.next.emit();
            });
    }
}
